import { api, shapeBlockData, shapeRelatedPostsData } from '@services/Api'
import queryString from 'query-string';
import { Author, Image } from '@customTypes/index';
import {removeEncodedChars} from "@lib/format";

interface Taxonomy {
  term_id: number;
  name: string;
  slug: string;
  term_group: number;
  term_taxonomy_id: number;
  taxonomy: string;
  description: string;
  parent: number;
  count: number;
  filter: string;
}
interface Data {
  title: string;
  ctaType: string;
  taxonomy: Taxonomy;
  postType?: any;
  orderBy?: any;
  perRow: number;
  total: number;
  order?: any;
  link: any;
  columns: any[];
}

interface Attrs {
  id?: any;
  name: string;
  data: Data;
}

interface Block {
  blockName: string;
  attrs: Attrs;
}

interface Components {
  template?: any;
  pagination?: any;
  header?: any;
  body?: any;
  footer?: any;
}

interface Taxonomy2 {
  category: boolean;
  tags: boolean;
}

interface Results {
  ID: number;
  title: string;
  slug: string;
  route?: string;
  content: any[];
  date: string;
  description?: string;
  blocks: Block[];
  parts: string[];
  collections: any;
  components: Components;
  author: Author;
  coAuthor: Author[];
  type: string;
  image: Image;
  gallery: Image[];
  taxonomy: Taxonomy2;
}

export const transformPageDataResponse = (data: any) => {

  const blocks = shapeBlockData(data?.results?.blocks);

  const layoutBlocks = shapeBlockData(data?.layout_builder?.blocks);

  const layoutRelatedPosts = shapeRelatedPostsData(data?.layout_builder?.relatedPosts?.results)

  const relatedPosts = shapeRelatedPostsData(data?.results?.relatedPosts?.results)

  return {
    ...data,
    results : {
      ...data.results,
      relatedPosts,
      blocks,
    },
    layout_builder: {
      ...data.layout_builder,
      blocks: layoutBlocks,
      relatedPosts: layoutRelatedPosts
    }
  };
};

const transformGetDescriptorBySlug = (responseData) => {
  const series = responseData;
  return {
    ...responseData,
    title: removeEncodedChars(responseData.title),
    description: removeEncodedChars(responseData.description),
  }
}

const pageApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPages: build.query({
      query: (params) => {
        return {
          url: `/covr/v1/pages/?${queryString.stringify(params, {
            arrayFormat: 'comma'
          })}`,
          method: "GET",
        };
      },
      providesTags: [],
      transformResponse: transformPageDataResponse,
    }),
    getPageBySlug: build.query({
      query: (params) => {
        const slug = params ? params.slug : 1;
        return {
          url: `/covr/v1/pages/by_slug?slug=${slug}`,
          method: "GET",
        };
      },
      providesTags: [],
      transformResponse: transformPageDataResponse,
    }),
    getPageById: build.query({
      query: (params) => {
        return {
          url: `/covr/v1/pages/?${queryString.stringify(params, {
            arrayFormat: 'comma'
          })}`,
          method: "GET",
        };
      },
      providesTags: [],
      transformResponse: transformPageDataResponse,
    }),
    getDescriptorBySlug: build.query({
      query: (params) => {
        const slug = params ? params.slug : 1;
        return {
          url: `/covr/v1/descriptor/by_slug?slug=${slug}`,
          method: "GET",
        };
      },
      transformResponse: transformGetDescriptorBySlug,
    }),
  })
});

export const {
  useGetPagesQuery,
  useGetPageBySlugQuery,
  useGetPageByIdQuery,
  useGetDescriptorBySlugQuery,
} = pageApi;
